import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>பூர்வம் முன்னுரை</h1>
  
  
    <div class="greenhd">
        <strong>தலைப்பும் - குறிப்பும்</strong></div><hr class="orange"> 
   
   
    <div class="color4">
        <div class="div3">
  விவாஹம் முதல்நாள் நிகழ்ச்சிகள்
  மற்றும்
  விவாஹம் முஹூர்த்தநாள் நிகழ்ச்சிகள்
  படிப்படியாக விளக்கப்பட்டுள்ளன.	    
        </div></div><hr class="orange"> 
   
   
    <div class="greenhd">
        <strong>பூர்வம் - சுபகார்யங்கள்</strong></div>
        <hr class="orange"> 
   
   
        <div class="div3">
        <span style="color: red"><strong>வைதீக அடிப்படை :</strong></span> இது ஒரு விரிவான
        வைதீக ப்ரயோகம் பற்றிய பகுதி. இது சாதாரணமாக வைதீக விஷயங்களையும் அதன் முக்கியத் துவத்தையும்
        அறிந்து கொள்பவர்களுக்காக மட்டுமன்றி வெளிநாடுகளிலும் வாத்யார்கள் கிடைக்காத பகுதியில்
        தாங்களாகவே எல்லாவிதமான வைதீக காரியங்களையும் தாங்களே நடத்திக்கொள்ள - உதவி.</div><hr class="orange"> 
   
   
    <div class="div3">
        <span style="color: red"><strong>ப்ரஸவ புண்யாஹம்&nbsp;</strong></span> பீஜதானம்
        ஆணோ, பெண்ணோ குழந்தை பிறந்த 11ம் நாள் பண்ணவேண்டும்.</div><hr class="orange"> 
   
   
    <div class="div3">
        <strong><span style="color: red">ஆயுஷ்யஹோமம்</span></strong> ஒரு வயது நிறைவு (ஆண்டு
        நிறைவு) மற்றும் ஷஷ்டியப்த பூர்த்தி ஆகிய வற்றில் செய்யப்படும்.</div><hr class="orange"> 
   
   
    <div class="div3">
        <strong><span style="color: red">அங்குரம்</span></strong> உபநயனம் மற்றும் விவாஹம்
        ஆகிய இரண்டு கர்மாக்களில் அங்குரம் எனும் பாலிகை பூஜை செய்யப்படவேண்டும்.
    </div><hr class="orange"> 
   
   
    <div class="div3">
        <strong><span style="color: red">ப்ரதிசரம்&nbsp;</span></strong> உபநயனம் மற்றும்
        விவாஹம் ஆகிய இரண்டு கர்மாக்களில் ப்ரதிசரம் என்னும் ரக்ஷாபந்தனம் பண்ணவேண்டும்.</div><hr class="orange"> 
   
   
    <div class="div3">
        <strong><span style="color: red">ஜாதகர்மா</span></strong> பெண்ணுக்குகல்யாணத்தன்றும்
        ஆணுக்கு உபநயனத்தன்றும் (பிறந்த அன்று செய்யவேண்டிய) ஜாதகர்மா செய்யப்படுகிறது.</div><hr class="orange"> 
   
   
    <div class="div3">
        <strong><span style="color: red">&nbsp;நாந்தி</span></strong> பித்ருக்களைஉத்தேசித்து
        பூர்வ கார்யங்களில் செய்யப்படும் ச்ராத்தம் 9 பேருக்கு தக்ஷpணைகள் கொடுக்கவேண்டும்.
    </div><hr class="orange"> 
   
   
    <div class="div3">
        <strong><span style="color: red">நாமகரணம்</span></strong> வைதீக ரீதியாக பெயர் வைக்கும்
        கர்மா. ஆணுக்கு உபநயனத்திலும் பெண்ணுக்கு விவாஹத்தன்றும் செய்யப்படுகிறது.
    </div><hr class="orange"> 
   
   
    <div class="div3">
        <strong><span style="color: red">அன்னப்ராசனம்</span></strong> வைதீக ரீதியாக அன்னம்
        கொடுப்பது. ஆணுக்கு உபநயனத்திலும் பெண்ணுக்கு விவாஹத்தன்றும் செய்யப் படுகிறது.</div><hr class="orange"> 
   
   
    <div class="div3">
        <strong><span style="color: red">சௌளம்</span></strong> ஆணுக்கு உபநயனத்துக்கு முன்
        சிகை வைக்கும் நிகழ்ச்சி. பெண்ணுக்கு சூடா கர்மா என்ற பெயரில் செய்யப்படுகிறது.</div><hr class="orange"> 
   
   
    <div class="div3">
        <strong><span style="color: red">உபநயனம்</span></strong> ப்ரஹ்மத்தின் அருகில் அழைத்துச்
        செல்லுதல். நித்யாநுஷ்டான யோக்யதை பெறுதல். ஆணுக்கு மட்டும்.</div><hr class="orange"> 
   
   
    <div class="div3">
        <strong><span style="color: red">ப்ரஹ்மோபதேசம்</span></strong> உபநயனமான பையனுக்கு
        காயத்திரி மந்திர உபதேசம் செய்வது.</div><hr class="orange"> 
   
   
        <div class="div3">
        <strong><span style="color: red">அஷ்டவ்ரதம்</span></strong> விவாஹம் செய்ய முடிவெடுத்த
        ப்ரும்மச்சாரி தன் ப்ரஹ்மச்சர்யத்தை முடித்துக்கொள்ளும் நிகழ்ச்சி</div><hr class="orange"> 
   
   
    <div class="div3">
        <strong><span style="color: red">பெண்-ஜாதகாதி</span></strong> விவாஹத்தன்றோ முதல்
        நாளோ பெண்ணுக்குச் செய்யப்படும் ஜாதகர்ம, நாமகரண, அன்னப்ராசன, சூடாகர்மாக்கள்</div><hr class="orange"> 
   
   
    <div class="div3">
        <strong><span style="color: red">விவாஹம்</span></strong> நிச்சயிக்கப்பட்ட ஒரு ஆணுக்கும்
        பெண்ணுக்கும் வைதீக ரீதியாக நடத்தப்படும் கல்யாணம் .</div><hr class="orange"> 
   
   
    <div class="div3">
        &nbsp;<strong><span style="color: red">க்ருஹப்ரவேசம்</span></strong> விவாஹம் முடிந்தவுடன்
        செய்யப்படுவது வதூ க்ருஹப்ரவேசம். புது வீடு கட்டி குடிபுகுவது நு}தன க்ருஹ ப்ரவேசம்.</div><hr class="orange"> 
   
   
    <div class="div3">
        &nbsp;<strong><span style="color: red">பும்ஸவனம்</span></strong> கர்பவதியானவளுக்கு
        4ம் மாதத்தில் ஆண் குழந்தை தரிக்க ஹோமம் பண்ணி மூக்குப் பிழிவது.</div><hr class="orange"> 
   
   
    <div class="div3">
        <strong><span style="color: red">&nbsp;ஸீமந்தம்</span></strong> கர்பவதியானவளுக்கு
        6 அல்லது 8ம் மாதத்தில் குழந்தை வயிற்றிலிருக்கும்போதே வகிடெடுத்து ப்ராஹ்மணதன்மை ஏற்
        படுத்துவது.
    </div><hr class="orange"> 
   
   
    <div class="div3">
        <strong><span style="color: red">
        மனை முஹூர்த்தம் </span>:- </strong>புதிய மனையில்
        வீடுகட்ட அஸ்திவாரம் போட நல்ல வாஸ்து உள்ள நாளில் செய்யப்படுவது.</div><hr class="orange"> 
   
   
    <div class="div3">
        <span style="color: red"><strong>ஷஷ்டியப்த பூர்த்தி :</strong><span style="color: #00008b">60
         வயது முடிந்து &nbsp;61வது பிறந்த நக்ஷத்திரத்து அன்று அறிந்தம் அறியாமலும் செய்த பாப
         காரியங்களால் ஏற்பட்ட அரிஷ்டம் எனப்படும் ஒருவகை தோஷத்தை வேத மந்திரங்களால் ஜபக்கப்பட்ட
         நீரை நல்ல வேளையில் சேர்த்துக் கொள்வதால்&nbsp; தேஹ உபாதைகள் நீங்கி ஆரோக்யம் உண்டாகும்.</span></span></div><hr class="orange"> 
   
   
    <div class="div3">
        <span style="color: red"><strong>
        சதாபிஷேகம் </strong>: <span style="color: #00008b">
         60 வது போலவே 80 முடிந்து 81வது&nbsp; 83வது பிறந்த நக்ஷத்திரத்து அன்றும் வேத மந்திரங்களால்
         ஜபக்கப்பட்ட நீரை நல்ல வேளையில் சேர்த்துக் கொள்வதால்&nbsp; தேஹ உபாதைகள் நீங்கி ஆரோக்யம்
         உண்டாகும்.</span></span></div><hr class="orange">`;

const PoorvamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="பூர்வம் முகப்பு - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default PoorvamPage;
